<!--Main Navigation-->
<header>
    <!--Navbar-->
    <mdb-navbar [containerInside]="false" id="generalnav" Class="navbar navbar-expand-lg navbar-light dooya-yellow">
        <mdb-navbar-brand>
            <a class="navbar-brand" href="https://trading.dooya.co.za">
                <img src="../../../assets/img/DooyaThin.png" height="48" alt="Dooya Logo" >
            </a>            
        </mdb-navbar-brand>
    </mdb-navbar>
    <!--/.Navbar-->

</header>
<!--Main Navigation-->